export default "__VITE_ASSET__DTYKh6nf__"